import React, { useContext } from 'react';
import contactenosContext from '../../context/contactenos/contactenosContext';
import urlImages from '../../config/urlImages'

const Banner = () => {

    const { banner } = useContext(contactenosContext);

    return (
        <section className='first_section' id="banner_quienes_somos" style={{backgroundImage: `url("${urlImages}uploads/contactenos/${banner?.img}")`}}> 
            <div>
                <h1>{banner?.title}</h1>
                <p>
                    {banner?.body}
                </p>
            </div>
        </section>
    );
}

export default Banner;